export function urlChanged(prevProps, props) {
  if (prevProps.location.pathname !== props.location.pathname || prevProps.location.search !== props.location.search) {
    return true;
  }

  /*if (prevProps.location.search !== "" || props.location.search !== "") {
    let oldParams = new URLSearchParams(prevProps.location.search);
    let params = new URLSearchParams(props.location.search);

    if (oldParams.get("page") !== params.get("page")) {
      return true;
    }
  }*/

  return false;
}

export function mergeParams(currentSearchString, newSearchString) {
  let currentObject = urlStringToObject(currentSearchString);
  let newObject = urlStringToObject(newSearchString);

  return new URLSearchParams({ ...currentObject, ...newObject }).toString();
}

export function urlStringToObject(urlString) {
  if (!urlString || urlString === "") {
    return {};
  }

  if (urlString.substring(0, 1) === "?") {
    urlString = urlString.substring(1);
  }

  return JSON.parse('{"' + decodeURI(urlString.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}')
}